module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nprogress-container'), _vm._v(" "), _c('navbar', {
    attrs: {
      "show": true
    }
  }), _vm._v(" "), _c('sidebar', {
    attrs: {
      "show": _vm.sidebar.opened && !_vm.sidebar.hidden && _vm.auth.authenticated
    }
  }), _vm._v(" "), _c('messages'), _vm._v(" "), _c('app-main'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a0f9d9a"}!./client/app/template.html
// module id = 226
// module chunks = 17